import { HTTP } from '@/services/axios';

export async function getMutations({filterText,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/core/Mutation/getMutationList.php',{
        params:{
            filterText,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getMutation({mutationId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/core/Mutation/getMutationData.php?mutationId=${mutationId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

export async function getMutationOptions(){
    let result = {};
    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/core/Mutation/getMutationOptions.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function unlockMutation({mutationId}){
    let result = {};

    var data = {'myRecordID':mutationId};
    
    await HTTP({
        method: 'patch',
        url: '/app/core/Mutation/controlMutationUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createMutation({data}){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Mutation/controlMutationSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveMutation({data}){
    let result = {};

    await HTTP({
        method: 'put',
        url: '/app/core/Mutation/controlMutationSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteMutation({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/core/Mutation/controlMutationDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}